export const QuizPopupName = 'QUIZ'
